import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { setPlaylistDialogOpen } from '../../store/map3UISlice';
import {
  Dialog,
  DialogTitle,
  DialogDescription,
  DialogBody,
} from '../../components_catalyst/dialog';
import { VideoEmbed } from './VideoEmbed1';

export function PlaylistDialog() {
  const dispatch = useDispatch();
  const playlistDialogIsOpen = useSelector((state: RootState) => state.map3UI.playlistDialogIsOpen);
  const playlist = useSelector((state: RootState) => state.map3UI.activePlaylist);
  const title = useSelector((state: RootState) => state.map3UI.activePlaylistTitle);
  const description = useSelector((state: RootState) => state.map3UI.activePlaylistDescription);

  return (
    <Dialog open={playlistDialogIsOpen} onClose={() => dispatch(setPlaylistDialogOpen(false))}>
      <DialogTitle>{title}</DialogTitle>
      <DialogDescription>{description}</DialogDescription>
      <DialogBody>
        {playlist.map((item, index) => (
          <div key={index} className="flex flex-col gap-6">
            <div>
              <h3 className="font-semibold text-lg">Video {index + 1}</h3>
              <VideoEmbed url={item.url} />
            </div>
          </div>
        ))}
      </DialogBody>
    </Dialog>
  );
}
